<template>
	<MoleculeContentBlock :image-position="imagePosition">
		<template #image>
			<div>
				<div
					class="rounded-full w-[12.5rem] h-[12.5rem] bg-gradient-to-b from-transparent to-purple-200 flex items-center"
				>
					<AtomImage
						class="-mt-16"
						v-bind="image"
						:width="200"
						:height="200"
					/>
				</div>
			</div>
		</template>
		<template #content>
			<AtomTitle
				tag="h3"
				size="lg"
			>
				{{ title }}
			</AtomTitle>
			<p
				class="text-paragraph-size-sm lg:text-paragraph-size-md"
			>
				{{ text }}
			</p>
			<LazyAtomLink
				v-if="link"
				class="flex gap-2 items-center text-paragraph-size-sm lg:text-paragraph-size-md"
				v-bind="link.to"
			>
				{{ link.text }}
				<LazyAtomFontAwesome
					icon="fa-arrow-right"
					class="w-6 h-6"
				/>
			</LazyAtomLink>
		</template>
	</MoleculeContentBlock>
</template>

<script lang="ts" setup>
import type { ImageType } from '#base/core/types/ImageType';
import type { LinkType } from '#base/core/types/LinkType';

const {
	imagePosition = 'left',
} = defineProps<{
	title: string;
	text: string;
	link?: LinkType;
	image: ImageType;
	imagePosition?: 'left' | 'right';
}>();
</script>
